import {RETRIEVE_DRIVER_LIST} from '@/api'
import {CREATE_DRIVER} from '@/api'
import {GET_DRIVER_INFO} from '@/api'
import {EDIT_DRIVER} from '@/api'
import {DELETE_DRIVER} from '@/api'

export default {
  retrieveDriverList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // console.log(response);
      if (response.data.data.driver_list.length) {
        commit('retrieveDriverList', {driverList: response.data.data.driver_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_DRIVER_LIST({}, successCallback, errorCallback)
  },

  createDriver({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.driver_info) {
        // commit('retrieveBusList', {busList: response.data.data.driver_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_DRIVER({data: payload.data}, successCallback, errorCallback)
  },

  editDriver({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.driver_info) {
        // commit('retrieveBusList', {busList: response.data.data.bus_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_DRIVER({data: payload}, successCallback, errorCallback)
  },

  getDriverInfo({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.driver_info) {
        commit('getDriverInfo', {driverInfo: response.data.data.driver_info})
      }
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    GET_DRIVER_INFO({payload}, successCallback, errorCallback)
  },

  deleteDriver({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteDriver', {driverInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_DRIVER({payload}, successCallback, errorCallback)
  }
};
